import { render, staticRenderFns } from "./VCurrencyField.vue?vue&type=template&id=834a447a"
import script from "./VCurrencyField.vue?vue&type=script&lang=js"
export * from "./VCurrencyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports